import api from "@/api";
import DataResponse from "@/types/DataResponse";
import Row from "@/types/Mapping/Row";
import { AxiosResponse } from "axios";

export default async function getSectionRows(eventId: string, sectionId: string): Promise<Row[]> {
  const response: AxiosResponse<DataResponse<Row[]>> = await api.get(`/api/events/${eventId}/sections/${sectionId}/seats`);
  return response.data.data;
}
